import { en } from './en';
import { de } from './de';
import { es } from './es';
import { cs } from './cs';
import { zh } from './zh';
import { zh_tw } from './zhtw';
import { ko } from './ko';
import { ja } from './ja';
import { fr } from './fr';

export const translations = {
  en,
  de,
  es,
  cs,
  zh,
  zh_tw,
  ko,
  ja,
  fr,
}



// WEBPACK FOOTER //
// ./src/constants/translations/index.js